export class SlideshowContentStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<SlideshowContentStyle>): SlideshowContentStyle {
    const pureStyles = new SlideshowContentStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
